function _typeof(o) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) {
    return typeof o;
  } : function (o) {
    return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
  }, _typeof(o);
}
function _regenerator() {
  /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */var e,
    t,
    r = "function" == typeof Symbol ? Symbol : {},
    n = r.iterator || "@@iterator",
    o = r.toStringTag || "@@toStringTag";
  function i(r, n, o, i) {
    var c = n && n.prototype instanceof Generator ? n : Generator,
      u = Object.create(c.prototype);
    return _regeneratorDefine2(u, "_invoke", function (r, n, o) {
      var i,
        c,
        u,
        f = 0,
        p = o || [],
        y = !1,
        G = {
          p: 0,
          n: 0,
          v: e,
          a: d,
          f: d.bind(e, 4),
          d: function d(t, r) {
            return i = t, c = 0, u = e, G.n = r, a;
          }
        };
      function d(r, n) {
        for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) {
          var o,
            i = p[t],
            d = G.p,
            l = i[2];
          r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0));
        }
        if (o || r > 1) return a;
        throw y = !0, n;
      }
      return function (o, p, l) {
        if (f > 1) throw TypeError("Generator is already running");
        for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) {
          i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u);
          try {
            if (f = 2, i) {
              if (c || (o = "next"), t = i[o]) {
                if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object");
                if (!t.done) return t;
                u = t.value, c < 2 && (c = 0);
              } else 1 === c && (t = i["return"]) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1);
              i = e;
            } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break;
          } catch (t) {
            i = e, c = 1, u = t;
          } finally {
            f = 1;
          }
        }
        return {
          value: t,
          done: y
        };
      };
    }(r, o, i), !0), u;
  }
  var a = {};
  function Generator() {}
  function GeneratorFunction() {}
  function GeneratorFunctionPrototype() {}
  t = Object.getPrototypeOf;
  var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () {
      return this;
    }), t),
    u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c);
  function f(e) {
    return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e;
  }
  return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () {
    return this;
  }), _regeneratorDefine2(u, "toString", function () {
    return "[object Generator]";
  }), (_regenerator = function _regenerator() {
    return {
      w: i,
      m: f
    };
  })();
}
function _regeneratorDefine2(e, r, n, t) {
  var i = Object.defineProperty;
  try {
    i({}, "", {});
  } catch (e) {
    i = 0;
  }
  _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) {
    function o(r, n) {
      _regeneratorDefine2(e, r, function (e) {
        return this._invoke(r, n, e);
      });
    }
    r ? i ? i(e, r, {
      value: n,
      enumerable: !t,
      configurable: !t,
      writable: !t
    }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2));
  }, _regeneratorDefine2(e, r, n, t);
}
function asyncGeneratorStep(n, t, e, r, o, a, c) {
  try {
    var i = n[a](c),
      u = i.value;
  } catch (n) {
    return void e(n);
  }
  i.done ? t(u) : Promise.resolve(u).then(r, o);
}
function _asyncToGenerator(n) {
  return function () {
    var t = this,
      e = arguments;
    return new Promise(function (r, o) {
      var a = n.apply(t, e);
      function _next(n) {
        asyncGeneratorStep(a, r, o, _next, _throw, "next", n);
      }
      function _throw(n) {
        asyncGeneratorStep(a, r, o, _next, _throw, "throw", n);
      }
      _next(void 0);
    });
  };
}
function _classCallCheck(a, n) {
  if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
}
function _defineProperties(e, r) {
  for (var t = 0; t < r.length; t++) {
    var o = r[t];
    o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o);
  }
}
function _createClass(e, r, t) {
  return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", {
    writable: !1
  }), e;
}
function _toPropertyKey(t) {
  var i = _toPrimitive(t, "string");
  return "symbol" == _typeof(i) ? i : i + "";
}
function _toPrimitive(t, r) {
  if ("object" != _typeof(t) || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != _typeof(i)) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}
var SaitoOverlay = require('./../../../../lib/saito/ui/saito-overlay/saito-overlay');
var JoinLeagueTemplate = require('./join.template');
var SaitoLoader = require('./../../../../lib/saito/ui/saito-loader/saito-loader');
var JoinLeague = /*#__PURE__*/function () {
  function JoinLeague(app, mod) {
    var _this = this;
    var league_id = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '';
    _classCallCheck(this, JoinLeague);
    this.app = app;
    this.mod = mod;
    this.league_id = league_id;
    this.overlay = new SaitoOverlay(app, mod, false, true);
    this.loader = new SaitoLoader(app, mod, '.league-join-overlay-box');
    this.timer = null;
    this.app.connection.on('join-league-success', function () {
      if (_this.timer) {
        clearTimeout(_this.timer);
        _this.timer = null;
      } else {
        //We have already faked success, so just stop here
        return;
      }
      _this.loader.remove();
      _this.render();
    });
  }
  return _createClass(JoinLeague, [{
    key: "render",
    value: function () {
      var _render = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
        var _this2 = this;
        var league;
        return _regenerator().w(function (_context) {
          while (1) switch (_context.n) {
            case 0:
              league = this.mod.returnLeague(this.league_id);
              if (!(league == null)) {
                _context.n = 1;
                break;
              }
              salert("League not found");
              console.debug('League [JoinLeague]: League not found' + this.league_id);
              return _context.a(2);
            case 1:
              this.overlay.remove();
              if (!(league.rank >= 0)) {
                _context.n = 2;
                break;
              }
              this.app.connection.emit('league-overlay-render-request', this.league_id);
              return _context.a(2);
            case 2:
              this.game_mod = this.app.modules.returnModuleByName(league.game);
              this.overlay.show(JoinLeagueTemplate(this.app, this.mod, league), function () {
                _this2.app.connection.emit('league-overlay-render-request', _this2.league_id);
              });
              this.overlay.setBackground(this.game_mod.respondTo('arcade-games').image);
              this.attachEvents();
            case 3:
              return _context.a(2);
          }
        }, _callee, this);
      }));
      function render() {
        return _render.apply(this, arguments);
      }
      return render;
    }()
  }, {
    key: "attachEvents",
    value: function attachEvents() {
      var _this3 = this;
      // Phase 1
      var league_join_btn = document.getElementById('league-join-btn');
      if (league_join_btn) {
        league_join_btn.onclick = /*#__PURE__*/function () {
          var _ref = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2(e) {
            var league_id, newtx, params;
            return _regenerator().w(function (_context2) {
              while (1) switch (_context2.n) {
                case 0:
                  window.history.replaceState('', '', window.location.pathname);
                  e.preventDefault();
                  league_id = e.target.getAttribute('data-id'); //
                  // show loader
                  //
                  document.querySelector('.title-box').remove();
                  document.querySelector('.league-join-controls').remove();
                  document.querySelector('.league-join-info').remove();
                  _this3.loader.render();
                  _context2.n = 1;
                  return _this3.mod.createJoinTransaction(league_id /*, user_email*/);
                case 1:
                  newtx = _context2.v;
                  _this3.app.network.propagateTransaction(newtx);
                  params = {
                    publickey: _this3.mod.publicKey
                  };
                  _context2.n = 2;
                  return _this3.mod.addLeaguePlayer(league_id, params);
                case 2:
                  _this3.timer = setTimeout(function () {
                    _this3.loader.remove();
                    _this3.render();
                    _this3.timer = null;
                  }, 2000);
                case 3:
                  return _context2.a(2);
              }
            }, _callee2);
          }));
          return function (_x) {
            return _ref.apply(this, arguments);
          };
        }();
        document.querySelector('#login').onclick = function (e) {
          _this3.app.connection.emit('recovery-login-overlay-render-request');
          return;
        };
      } else {
        document.querySelector('#gonow').onclick = function (e) {
          _this3.app.connection.emit('league-overlay-render-request', _this3.league_id);
          _this3.overlay.remove();
        };
        var countDown = document.getElementById('countdown');
        var timer = 9;
        var interval = setInterval(function () {
          timer--;
          countDown.innerHTML = timer;
          if (timer === 0) {
            clearInterval(interval);
            _this3.app.connection.emit('league-overlay-render-request', _this3.league_id);
            _this3.overlay.remove();
          }
        }, 1000);
      }
    }
  }]);
}();
module.exports = JoinLeague;